<template>
  <div>
    <ul v-if="tree && tree.length > 0">
      <li v-for="(reply, index) in tree" :id="`reply_${reply.id}`" :key="reply.id">
        <div :id="`feedback_${reply.id}`" class="comment-body">
          <div class="avatar-profile" @click.stop="directReport(reply)">
            <img
              :src="reply.owner.avatarUrl"
              :onerror="isNightMode ? avatarDefaultDark : avatarDefault"
              class="avatar"
            >
          </div>

          <div class="comment-wrap">
            <div>
              <div class="comment-top-info">
                <UserProfile :item-data="reply" />
              </div>

              <ContentBody
                type="comment"
                is-second-detail-comment="comment"
                :data="reply"
                @click="onReplyClick($event, reply)"
              />

              <MenuBar :type="type" :item-data="reply" />
            </div>
          </div>
        </div>
        <div v-if="reply.children && reply.children.length">
          <!-- <CommentSecondDetailReplyItem_v2 :key="`${reply.id}_${index}_CommentSecondDetailSubReply_v2`" :is-sub="true" :tree-data="reply.children" /> -->
          <CommentSecondDetailReplyItemV2
            :key="`${reply.id}_${index}_CommentSecondDetailSubReply_v2`"
            :tree-data="reply.children"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { toRefs, computed } from 'vue';

import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { commonCommentStat } from '../core/useStat';

import avatarDefault from '../assets/img/avatar_default.png';
import avatarDefaultDark from '../assets/img/avatar_default_dark.png';
import ContentBody from './ContentBody.vue';
import MenuBar from './MenuBar.vue';
import UserProfile from './UserProfile.vue';
import CommentSecondDetailReplyItem_v2 from './CommentSecondDetailReplyItem_v2.vue';

export default {
  name: 'CommentSecondDetailSubReplyV2',

  components: {
    ContentBody,
    MenuBar,
    UserProfile,
    CommentSecondDetailReplyItemV2: CommentSecondDetailReplyItem_v2,
  },
  props: {
    treeData: {
      type: Array,
      required: true,
    },
    commentId: {
      type: String,
      required: true,
      default: '',
    },
  },
  setup(props) {
    const { treeData, commentId } = toRefs(props);

    const { onCommentClickThrottle } = useOnCommentClickInject();

    const transformData = (data) => {
      const itemsById = {};

      data.forEach((item) => {
        if (!item.parentReplyId || item.isSubReply === false) {
          itemsById[item.id] = {
            children: [],
            ...item,
          };
        }
      });

      data.forEach((item) => {
        if (item.parentReplyId && item.isSubReply === true) {
          if (!itemsById[item.parentReplyId]) {
            itemsById[item.parentReplyId] = {
              children: [],
              ...item,
            };
          }
          const childItem = {
            ...item,
          };

          itemsById[item.parentReplyId].children.push(childItem);
        }
      });

      const result = Object.values(itemsById).filter((item) => {
        console.log('this.tree item', item);
        return commentId.value === item.commentId;
      });
      return result;
    };

    const onReplyClick = (event, reply) => {
      onCommentClickThrottle(reply, {
        directComment: true,
      });
      event.stopPropagation();
    };

    const directReport = (reply) => {
      commonCommentStat(20084690, {
        userId: reply.owner.id,
      });

      if (uid === reply.owner.id) {
        return;
      }

      onCommentClickThrottle(reply, {
        directReport: true,
      });
    };

    const tree = computed(() => {
      console.log(
        'this.tree transformData(treeData.value)',
        transformData(treeData.value),
      );
      return transformData(treeData.value);
    });

    return {
      tree,

      onCommentClickThrottle,
      onReplyClick,
      directReport,
    };
  },
};
</script>

<style lang="scss" scoped>
/* 根据需要添加样式 */
@import "../assets/css/common.scss";
@import "../assets/css/loading.scss";
@import "../assets/css/load-bar.scss";
@import "../assets/css/styling-mixin.scss";

.avatar-profile {
  flex-shrink: 0;
  width: 108px;
  height: 108px;
  border-radius: 54px;
  position: relative;
  margin-top: 3px;
  &:active {
    transform: scale(0.8);
    transition: all 0.3s ease;
  }

  @include setRounded1pxBorder(rgba(0, 0, 0, 0.1), before, 54px);

  .avatar {
    width: 108px;
    height: 108px;
    border-radius: 54px;
    margin-top: 0;
    vertical-align: top;
  }
}

.load-bar {
  .load-bar-nothing {
    @include os-browser-styling(13, "not-video") {
      margin-top: 66px;
    }
  }
}

// 分割啦

.comment-item {
  color: #000;
}

.comment-body {
  display: flex;
  padding: 18px 48px;
}

.only-comment {
  padding-bottom: 18px;
}

.tag {
  width: 108px;
  height: 108px;
  border-radius: 54px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 54px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &-hot {
    &::after {
      background-image: url("../assets/img/hot-circle.png");
    }
  }

  &-good {
    &::after {
      background-image: url("../assets/img/good-circle.png");
    }
  }
  &-god {
    &::after {
      background-image: url("../assets/img/god-circle.png");
    }
  }
}

.comment-wrap {
  margin-left: 24px;
  font-size: 36px;
  font-family: ColorFont-Regular, "OPlusSans 3.0";
  flex: 1;
  min-width: 0; // fix flex & ellipsis
  .all-comment-area {
    @include os-browser-styling(13, "not-video") {
      margin: 12px 0;
    }
  }

  .comment-top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 15px 0 6px 0;
  }
}

html[data-theme="dark"] {
  .no-network-connection {
    background: url("../assets/img/no-network-connection_dark.png") center center /
      contain no-repeat;
  }
  .comment-content {
    color: rgba(255, 255, 255, 0.7);
  }
}
</style>
